
import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { HttpResponse } from '../../interfaces/auth/AuthInterface';

import { BuscarListadoEntregaParams, BuscarListadoEntregaResponse, GenerarDocumentoListadoEntregaResponse, GenerarListadoEntregaParams, NuevoListadoEntregaResponse, DetalleListadoEntregaResponse, DetalleListadoEntregaTablaParams, ListadoEntregaRecepcionProps, defaultBuscarListadoEntregaResponse, defaultDetalleListadoEntregaResponse } from '../../interfaces/comun/ListadoEntregaInterface';

export const NuevoListadoEntrega = ( ) => {

    return new Promise<NuevoListadoEntregaResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClienteToken.get('/Api/ListadoEntrega/NuevoListadoEntrega', token)
            .then( ({ data } : { data : NuevoListadoEntregaResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                   success: false,
                   message: error.message,
                   idListadoEntrega: ''
                });
            });
        }

    });

}

export const DetalleListadoEntrega = ( id: string ) => {

    return new Promise<DetalleListadoEntregaResponse>( ( resolve, eject ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get(`/Api/ListadoEntrega/DetalleListadoEntrega/${ id }`, token)
            .then( ({ data } : { data : DetalleListadoEntregaResponse } ) => {  
                resolve( data );                
            })
            .catch( (  ) => {
                resolve({ ...defaultDetalleListadoEntregaResponse });
            });
        }

    });

}

export const DetalleListadoEntregaTabla = ( params: DetalleListadoEntregaTablaParams ) => {

    return new Promise<ListadoEntregaRecepcionProps[]>( ( resolve, eject ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/ListadoEntrega/DetalleListadoEntregaTabla/', params, token)
            .then( ({ data } : { data : ListadoEntregaRecepcionProps[] } ) => {  
                resolve( data );                
            })
            .catch( (  ) => {
                resolve( [] );
            });
        }

    });

}

export const GenerarListadoEntrega = ( params: GenerarListadoEntregaParams ) => {

    return new Promise<GenerarDocumentoListadoEntregaResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClienteToken.post('/Api/ListadoEntrega/GenerarListadoEntrega',params, token)
            .then( ({ data } : { data : GenerarDocumentoListadoEntregaResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError  ) => {
                resolve({
                    success: false,
                    message: error.message,
                    documento: '',
                });
            });

        }

    });

}

export const FinalizarListadoEntrega = ( id: string ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClienteToken.get(`/Api/ListadoEntrega/FinalizarListadoEntrega/${ id }`, token)
            .then( ({ data } : { data : HttpResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError  ) => {
                resolve({
                   success: false,
                   message: error.message,
                });
            });
            
        }

    });

}

//-------------------------------------------------------------------------------------------------------------------------------------------------

export const BuscarListadoEntrega = ( params: BuscarListadoEntregaParams ) => {

    return new Promise<BuscarListadoEntregaResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post(`/Api/ListadoEntrega/BuscarListadoEntrega/`, params, token)
            .then( ({ data } : { data : BuscarListadoEntregaResponse } ) => {  
                resolve( data );                
            })
            .catch( (   ) => {
                resolve({ ...defaultBuscarListadoEntregaResponse });
            });
        }

    });

}